export default __webpack_public_path__ + "static/media/SHPE.b2aa665f.svg";